import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive } from "vue"

import { reactive, onMounted } from "vue";
import CardBoard from "@/components/home/CardBoard.vue";
import CaseService from "@/services/case-service";
import { MOST_NEEDED_SPECIALTY_ID } from "@/services/enum.service";


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendationCard',
  props: {
    donation_type: {
        type: String,
        default: null
    },
    speciality_id: {
        type: [String, Number],
        default: null
    },
    // Show a grid of "most needed" cases instead of a single recommended card.
    most_needed: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props;

const state = reactive({
    cases: [],
    type: 'case',
})

// Same query the cases listing runs for the "الأكثر حاجة" speciality, so the
// screen shows the cases that need donations most rather than ones matching the
// completed case's own speciality.
const fetchMostNeededCases = () => {
    CaseService.getCaseCardList({
        page: 1,
        page_size: 9,
        specialty: MOST_NEEDED_SPECIALTY_ID,
    }).then(({ data: { result } }) => {
        state.type = 'cases';
        state.cases = result?.results ?? [];
    });
}

const fetchCases = () => {
   const params: { donation_type?: string; speciality_id?: string | number } =
     props.donation_type === 'waqf' ? { donation_type: 'waqf' } : {};
   if (props.speciality_id) {
     params.speciality_id = props.speciality_id;
   }
   CaseService.getRecommendedCard(1, params).then((response) => {
        state.type = response.data.result[0].type === 'waqf' ? 'endowments' : response.data.type;
        state.cases = response.data.result;
   })
}

onMounted(() => {
    if (props.most_needed) {
        fetchMostNeededCases();
        return;
    }
    fetchCases();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_KeepAlive, null, [
    (state.cases.length)
      ? (_openBlock(), _createBlock(CardBoard, {
          key: 0,
          type: state.type,
          items: state.cases
        }, null, 8, ["type", "items"]))
      : _createCommentVNode("", true)
  ], 1024))
}
}

})